module.exports = __webpack_public_path__ + "icon_vaaka_2.afc04ff1551d6fdd5c13.svg";